import { Component, ElementRef, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { KkmsApiService } from '../../../core/modules/kkms/kkms-api.service';

@Component({
  selector: 'tax-token',
  templateUrl: './token.component.html',
  styleUrls: ['./token.component.sass'],
})

export class TokenComponent implements OnDestroy {
  // @ts-ignore
  @Input() kkmId: number;

  private subscription: Subscription[] = [];
  token: string = '';
  element: any;
  constructor(
    private el: ElementRef,
    private kkmsApiService: KkmsApiService,
  ) {
    this.element = el.nativeElement;
  }

  getToken(): void {
    this.subscription.push(this.kkmsApiService.fetchToken(this.kkmId.toString()).subscribe(
      response => this.token = response,
    ));
  }

  ngOnDestroy(): void {
    this.subscription.forEach((item: Subscription) => item.unsubscribe());
  }
}
